import cookie from 'js-cookie';
import { useEffect } from 'react';
import { PCI_PAL_AGENT_STORAGE_KEY } from '../Signup/hooks/useAgentMode/utils/pciPalAgentCookie';
import { useLocation } from 'react-router';

const MODE_PARAM = 'mode';
const AGENT_MODE_VALUE = 'agent';

const cookieAllowList = [PCI_PAL_AGENT_STORAGE_KEY];

export function useResetAgentSignupSession() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hasAgentModeQueryParam = params.get(MODE_PARAM) === AGENT_MODE_VALUE;

  useEffect(() => {
    if (hasAgentModeQueryParam) {
      localStorage.clear();

      // Delete client cookies that are not in the allow list
      Object.keys(cookie.get()).forEach(cookieName => {
        if (cookieAllowList.includes(cookieName)) {
          return;
        }

        cookie.remove(cookieName, { path: '/' });
      });
    }
  }, [hasAgentModeQueryParam]);
}
